"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _District = _interopRequireDefault(require("./District"));

var _County = _interopRequireDefault(require("./County"));

var _ZipCode = _interopRequireDefault(require("./ZipCode"));

var _RawData = _interopRequireDefault(require("../data/RawData"));

var _RawDataSort = _interopRequireDefault(require("../data/RawDataSort"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 組合元件
 *
 * @author Chris Tsai
 */
var ZipCodeTW =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ZipCodeTW, _React$Component);

  function ZipCodeTW(props) {
    var _this;

    _classCallCheck(this, ZipCodeTW);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZipCodeTW).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initData", function () {
      var counties = Object.keys(_RawData.default);
      var _this$props = _this.props,
          countyValue = _this$props.countyValue,
          districtValue = _this$props.districtValue,
          zipCodeValue = _this$props.zipCodeValue,
          countyFieldName = _this$props.countyFieldName,
          districtFieldName = _this$props.districtFieldName,
          zipCodeFieldName = _this$props.zipCodeFieldName,
          countySort = _this$props.countySort;

      if (typeof countySort != 'undefined') {
        counties.sort(function (a, b) {
          return countySort[a] - countySort[b];
        });
      } else {
        counties.sort(function (a, b) {
          return _RawDataSort.default[a] - _RawDataSort.default[b];
        });
      }

      var county = countyValue === '' ? counties[0] : countyValue;
      var district;
      var zipCode = typeof zipCodeValue == 'undefined' ? '' : zipCodeValue;
      var countyRaw = _RawData.default[county];
      var districts = typeof countyRaw == 'undefined' ? [] : Object.keys(countyRaw).map(function (d) {
        return d;
      }, []);

      if (typeof districts != 'undefined' && districts.length > 0) {
        if (districtValue === '') {
          district = districts[0];
        } else if (districts.indexOf(districtValue) > -1) {
          district = districtValue;
        } else {
          district = districts[0];
        }

        zipCode = _RawData.default[county][district];
      }

      var nowCountyFieldName = typeof countyFieldName != 'undefined' && countyFieldName !== '' ? countyFieldName : 'county';
      var nowDistrictFieldNam = typeof districtFieldName != 'undefined' && districtFieldName !== '' ? districtFieldName : 'district';
      var nowZipCodeFieldName = typeof zipCodeFieldName != 'undefined' && zipCodeFieldName !== '' ? zipCodeFieldName : 'zipCode';

      _this.setState({
        county: county,
        district: district,
        zipCode: zipCode,
        counties: counties,
        districts: districts,
        countyFieldName: nowCountyFieldName,
        districtFieldName: nowDistrictFieldNam,
        zipCodeFieldName: nowZipCodeFieldName
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChangeCounty", function (county) {
      var districts = Object.keys(_RawData.default[county]).map(function (d) {
        return d;
      }, []);
      var district = districts[0];
      var zipCode = _RawData.default[county][districts[0]];
      var handleChangeCounty = _this.props.handleChangeCounty;
      var _this$state = _this.state,
          countyFieldName = _this$state.countyFieldName,
          districtFieldName = _this$state.districtFieldName,
          zipCodeFieldName = _this$state.zipCodeFieldName;

      _this.setState({
        county: county,
        districts: districts,
        district: district,
        zipCode: zipCode
      }, function () {
        if (typeof handleChangeCounty == 'function') {
          handleChangeCounty({
            'countyFieldName': countyFieldName,
            'countyValue': county,
            'districtFieldName': districtFieldName,
            'districtValue': district,
            'zipFieldName': zipCodeFieldName,
            'zipValue': zipCode
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChangeDistrict", function (district) {
      var zipCode = _RawData.default[_this.state.county][district];
      var handleChangeDistrict = _this.props.handleChangeDistrict;
      var _this$state2 = _this.state,
          countyFieldName = _this$state2.countyFieldName,
          districtFieldName = _this$state2.districtFieldName,
          zipCodeFieldName = _this$state2.zipCodeFieldName;

      _this.setState({
        district: district,
        zipCode: zipCode
      }, function () {
        if (typeof handleChangeDistrict == 'function') {
          handleChangeDistrict({
            'countyFieldName': countyFieldName,
            'countyValue': _this.state.county,
            'districtFieldName': districtFieldName,
            'districtValue': district,
            'zipFieldName': zipCodeFieldName,
            'zipValue': zipCode
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChangeZipCode", function (zipCode) {
      var handleChangeZipCode = _this.props.handleChangeZipCode;
      var zipCodeFieldName = _this.state.zipCodeFieldName;

      _this.setState({
        zipCode: zipCode
      }, function () {
        if (typeof handleChangeZipCode == 'function') {
          handleChangeZipCode({
            'zipFieldName': zipCodeFieldName,
            'zipValue': zipCode
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlurZipCode", function (zipCode) {
      var _this$findCountyAndDi = _this.findCountyAndDistrictByZipCode(zipCode),
          countyN = _this$findCountyAndDi.countyN,
          districtN = _this$findCountyAndDi.districtN;

      var _this$props2 = _this.props,
          handleZipCodeNotExists = _this$props2.handleZipCodeNotExists,
          handleBlurZipCode = _this$props2.handleBlurZipCode;
      var _this$state3 = _this.state,
          countyFieldName = _this$state3.countyFieldName,
          districtFieldName = _this$state3.districtFieldName,
          zipCodeFieldName = _this$state3.zipCodeFieldName;

      if (typeof countyN != 'undefined' && typeof districtN != 'undefined') {
        var districts = Object.keys(_RawData.default[countyN]).map(function (d) {
          return d;
        }, []);

        _this.setState({
          county: countyN,
          district: districtN,
          districts: districts
        }, function () {
          if (typeof handleBlurZipCode == 'function') {
            handleBlurZipCode({
              'countyFieldName': countyFieldName,
              'countyValue': countyN,
              'districtFieldName': districtFieldName,
              'districtValue': districtN,
              'zipFieldName': zipCodeFieldName,
              'zipValue': zipCode
            });
          }
        });
      } else {
        _this.setState({
          county: '',
          district: '',
          districts: [],
          zipCode: ''
        }, function () {
          if (typeof handleZipCodeNotExists == 'function') {
            handleZipCodeNotExists({
              'countyFieldName': countyFieldName,
              'countyValue': '',
              'districtFieldName': districtFieldName,
              'districtValue': '',
              'zipFieldName': zipCodeFieldName,
              'zipValue': '',
              'origZipValue': zipCode
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "findCountyAndDistrictByZipCode", function (zipCode) {
      var rtn = {};
      Object.keys(_RawData.default).forEach(function (countyN) {
        Object.keys(_RawData.default[countyN]).forEach(function (districtN) {
          if (_RawData.default[countyN][districtN] === zipCode.toString()) {
            rtn = {
              countyN: countyN,
              districtN: districtN
            };
          }
        });
      });
      return rtn;
    });

    _this.state = {
      countyFieldName: 'county',
      districtFieldName: 'district',
      zipCodeFieldName: 'zipCode',
      county: 'county',
      counties: [],
      district: 'district',
      districts: [],
      zipCode: 'zipCode',
      zipCodePlaceholder: ''
    };
    return _this;
  }

  _createClass(ZipCodeTW, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          countyValue = _this$props3.countyValue,
          districtValue = _this$props3.districtValue,
          zipCodeValue = _this$props3.zipCodeValue;

      if (prevProps.countyValue !== countyValue || prevProps.districtValue !== districtValue || prevProps.zipCodeValue !== zipCodeValue) {
        this.initData();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          zipStyle = _this$props4.zipStyle,
          countyStyle = _this$props4.countyStyle,
          districtStyle = _this$props4.districtStyle,
          zipClass = _this$props4.zipClass,
          countyClass = _this$props4.countyClass,
          districtClass = _this$props4.districtClass,
          displayType = _this$props4.displayType,
          zipCodePositionLast = _this$props4.zipCodePositionLast,
          countySort = _this$props4.countySort;
      var _this$props5 = this.props,
          fullAddress = _this$props5.fullAddress,
          address = _this$props5.address,
          addressClass = _this$props5.addressClass,
          addressStyle = _this$props5.addressStyle;
      var displayTypeFlag = displayType === 'display' ? true : false;
      var nowZipCodePositionLast = typeof zipCodePositionLast != 'undefined' ? zipCodePositionLast : true;
      var nowCountyStyle = typeof countyStyle != 'undefined' ? countyStyle : nowZipCodePositionLast ? {} : {
        marginLeft: '5px'
      };
      var nowDistrictStyle = typeof districtStyle != 'undefined' ? districtStyle : displayTypeFlag ? {} : {
        marginLeft: '5px',
        minWidth: '107px',
        paddingRight: '0px'
      };
      var nowZipStyle = typeof zipStyle != 'undefined' ? zipStyle : !displayTypeFlag && !nowZipCodePositionLast ? {
        width: '50px'
      } : {
        marginLeft: '5px',
        width: '50px'
      };
      var nowCountyClass = typeof countyClass != 'undefined' ? countyClass : 'form-control';
      var nowDistrictClass = typeof districtClass != 'undefined' ? districtClass : 'form-control';
      var nowZipClass = typeof zipClass != 'undefined' ? zipClass : 'form-control';
      var nowAddressClass = typeof addressClass != 'undefined' ? addressClass : 'form-control';
      return React.createElement(React.Fragment, null, displayTypeFlag || !displayTypeFlag && !nowZipCodePositionLast ? React.createElement(_ZipCode.default, {
        fieldName: this.state.zipCodeFieldName,
        value: this.props.zipCodeValue,
        zipClass: nowZipClass,
        zipStyle: nowZipStyle,
        placeholder: this.props.zipCodePlaceholder,
        displayType: displayType,
        onChange: this.handleChangeZipCode,
        onBlur: this.handleBlurZipCode
      }) : '', typeof fullAddress != 'undefined' && fullAddress !== '' && displayTypeFlag ? React.createElement("span", {
        className: nowAddressClass,
        style: addressStyle,
        readOnly: true,
        disabled: true
      }, fullAddress) : React.createElement(React.Fragment, null, React.createElement(_County.default, {
        fieldName: this.state.countyFieldName,
        value: this.props.countyValue,
        countyClass: nowCountyClass,
        countyStyle: nowCountyStyle,
        dataOptions: this.state.counties,
        displayType: displayType,
        onChange: this.handleChangeCounty
      }), React.createElement(_District.default, {
        fieldName: this.state.districtFieldName,
        value: this.props.districtValue,
        districtClass: nowDistrictClass,
        districtStyle: nowDistrictStyle,
        displayType: displayType,
        dataOptions: this.state.districts,
        onChange: this.handleChangeDistrict
      }), !displayTypeFlag && nowZipCodePositionLast ? React.createElement(_ZipCode.default, {
        fieldName: this.state.zipCodeFieldName,
        value: this.props.zipCodeValue,
        zipClass: nowZipClass,
        zipStyle: nowZipStyle,
        placeholder: this.props.zipCodePlaceholder,
        displayType: displayType,
        onChange: this.handleChangeZipCode,
        onBlur: this.handleBlurZipCode
      }) : '', typeof address != 'undefined' && address !== '' && displayTypeFlag ? React.createElement("span", {
        className: nowAddressClass,
        style: addressStyle,
        readOnly: true,
        disabled: true
      }, address) : ''));
    }
  }]);

  return ZipCodeTW;
}(React.Component);

exports.default = ZipCodeTW;
ZipCodeTW.propTypes = {
  displayType: _propTypes.default.oneOf(['text', 'display']).isRequired,
  fullAddress: _propTypes.default.string,
  zipCodePositionLast: _propTypes.default.bool,
  address: _propTypes.default.string,
  countyFieldName: _propTypes.default.string,
  countyValue: _propTypes.default.string,
  districtFieldName: _propTypes.default.string,
  districtValue: _propTypes.default.string,
  zipCodeFieldName: _propTypes.default.string,
  zipCodeValue: _propTypes.default.string,
  zipCodePlaceholder: _propTypes.default.string,
  handleChangeCounty: _propTypes.default.func,
  handleChangeDistrict: _propTypes.default.func,
  handleChangeZipCode: _propTypes.default.func,
  handleBlurZipCode: _propTypes.default.func,
  handleZipCodeNotExists: _propTypes.default.func,
  countyClass: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  countyStyle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  districtClass: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  districtStyle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  zipClass: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  zipStyle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  addressClass: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  addressStyle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]),
  countySort: _propTypes.default.object
};